import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

import Loader from "../../common/Loader";
import { useSidebar } from "../../common/SidebarContext";

const AuthElement = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const REDIRECT_URL = "https://app.avatare.com";
  const { profile, setProfile,setIsSupperAdmin } = useSidebar();

  useEffect(() => {
    const checkAuth = async () => {
      let token = searchParams.get("token") || localStorage.getItem("token");
      let userId = searchParams.get("userId") || localStorage.getItem("UserId");

      if (!token) {
        window.location.href = REDIRECT_URL;
        return;
      }

      try {
        if (searchParams.get("token")) {
          localStorage.setItem("token", token);
        }
        if (searchParams.get("userId")) {
          localStorage.setItem("UserId", userId);
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_ROOT}/api/auth/verify/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data === true) {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_API_ROOT}/api/auth/getprofile/?Id=${userId}`,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
            const data = res?.data?.message;
            setProfile(res?.data?.message);
            const email = data?.email.trim();
            setIsSupperAdmin(
              email === "daren.jackson@avatare.com" ||
                email === "osama@divedeepai.com" ||
                email === "e.divedeepai@gmail.com"
            );

            if (email.toLowerCase().includes("usu.edu")) {
              localStorage.setItem("Student", "yes");
            } else if (data?.email == "superadmin@avatare.com") {
              localStorage.setItem("Student", "yes");
            } else {
              localStorage.setItem("Student", "no");
            }
            localStorage.setItem("email", data?.email);

            localStorage.setItem("isOrganizer", data?.isOrganizer);
            localStorage.setItem("OrganizationId", data?.OrganizationId);

            // localStorage.setItem("",res.data?.message?.first_name+ res.data?.message?.last_name)
          } catch (error) {}
          navigate("/");
        } else {
          window.location.href = REDIRECT_URL;
        }
      } catch (error) {
        window.location.href = REDIRECT_URL;
      }
    };

    checkAuth();
  }, [searchParams, navigate]);

  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <Loader />
    </div>
  );
};

export default AuthElement;
